const gamedaysTabStyles = (theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  headerActions: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  gamesCell: {
    paddingTop: 0,
    paddingBottom: 0,
    backgroundColor: '#f8f9fa',
  },
  gamesContainer: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(6),
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    marginLeft: theme.spacing(2),
  },
  gameItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  gameChip: {
    marginLeft: theme.spacing(1),
  },
  expandButton: {
    transition: 'transform 0.2s',
  },
})

export default gamedaysTabStyles
